// @flow

import { getComponentSettings } from './main';

import { type State } from '../reducers';

type GlobalState = {
  componentSettings: State,
};

export type GallerySettings = $PropertyType<State, 'pdb_gallery'>;
export const getGallerySettings = (state: GlobalState): GallerySettings => {
  const gallery = getComponentSettings(state).pdb_gallery;
  if (!gallery) {
    throw new Error('Missing pdb_gallery settings in componentSettings store.');
  }
  return gallery;
};

type DisclaimerText = $PropertyType<GallerySettings, 'disclaimer_text'>;
export const getDisclaimerText = (state: GlobalState): DisclaimerText => (
  getGallerySettings(state).disclaimer_text
);

type TheaterButtonText = $PropertyType<GallerySettings, 'theater_button_text'>;
export const getTheaterButtonText = (state: GlobalState): TheaterButtonText => (
  getGallerySettings(state).theater_button_text
);
